import { Button } from "monday-ui-react-core"
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

const SelectOneProductModalComponent = ({
    showModal,
    closeModal
}) => {
    return (
    <>
        <Dialog
            open={showModal}
            fullWidth={false}
            maxWidth='md'
        >
            <DialogTitle>Only one Product can be selected</DialogTitle>
            <IconButton
                aria-label='close'
                onClick={closeModal}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500]
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent>
                <section className="mb-5">
                    <span>Only one Product can be selected.</span>                    
                    <br/>
                    <span>Please select rows with only Gas Balancing or Payout products.</span>
                </section>
            </DialogContent>
            <DialogActions>
                <Button className="success" marginRight={2} onClick={closeModal}>Ok</Button>
            </DialogActions>
        </Dialog>
    </>
    )
}
export default SelectOneProductModalComponent